"use strict";

export function initInScope($scope) {

    $scope.find('.js-form-auto-submit').on('change', function (e) {
        const $this = $(this);

        if ($this.data("field-target") && $this.data("value-target")) {
            $scope.find($this.data("field-target")).val($this.attr("name"));
            $scope.find($this.data("value-target")).val($this.val());
        }

        const $form = $(this).closest('form');
        const urlParams = new URLSearchParams(window.location.search);
        const currentFilter = urlParams.get('accfilter');

        $form.find('input[name="accfilter"]').remove();

        if (currentFilter) {
            $('<input>').attr({
                type: 'hidden',
                name: 'accfilter',
                value: currentFilter
            }).appendTo($form);
        }
        
        $form.trigger("submit");
    });

}